import { Container } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';

function InfoCard(props) {
  return (
    <Container className='d-flex justify-content-center py-5'>
    <Card className="text-center w-75">
      <Card.Header></Card.Header>
      <Card.Body>
        <Card.Title className='fw-bold'>
          {
          props.tidbit 
          ? <> <h3>{props.p1}</h3>
          <br></br>
          <p className='fw-light'>Compatibility with: {props.difficult}</p> </>
          : 
          <><h3 className="fw-bolder"><b> {props.p1? props.p1:'ESFP'} vs {props.p2? props.p2:'ESFP'}</b></h3> 
          <br></br>
           <h4 className="fw-bold"> {props.head}</h4>
           </>
          }
          </Card.Title>
        <Card.Text>
         {/* check props.body has (http) and display without (http) */}
         {props.body && props.body.includes('http') ? props.body.slice(0, props.body.indexOf('http')-1) : props.body}

          
          {/* check if props.body has (http) then splice (http:// ) and display link*/}
          {props.body && props.body.includes('http') &&
          <a href={props.body.slice(props.body.indexOf('http'))} target="_blank" rel="noreferrer"> {props.body.slice(props.body.indexOf('http'))}</a>
          }
  
        </Card.Text>
      </Card.Body>
      <Card.Footer></Card.Footer>
    </Card>
    </Container>
  );
}

export default InfoCard;
